<h2 style="display: flex; font-size: x-large; justify-content: center;">
    Error 500. Please try again or contact McLane Helpdesk.
</h2>
